import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { i18n } from '../../../translate/i18n';
import filesize from "filesize";
import * as actions from "../../../store/actions";
import API from '../../../axios/api';
import { isEmpty, uniqueId, orderBy as orderByLoadash } from 'lodash';

import {
  Input, Container, Paper, Typography, FormControl, FormLabel, IconButton, TextField, FormControlLabel, Switch, RadioGroup, Radio, CircularProgress, Chip, Divider, Dialog, TableBody, TableRow, TableCell, Table, Button, Avatar, useMediaQuery, Icon, Tooltip, InputLabel, Select,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBack from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import FileCopyTwoToneIcon from '@mui/icons-material/FileCopyTwoTone';

import {
  FormStyled, DoneIconStyled, FormControlRadioStyled, DivSubmitButtons,
  DivFormTitle, DivSpinner,
} from './styles';
import { FormHelperText } from '@mui/material';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import confirm from '../../../UI/Confirm/confirm';
import Spinner from '../../../components/Spinner/index';
import { deleteCheckMessage } from '../../../utils/deleteCheckMessage';
import checkTenantFeatureFlag, { VIEW_EQUIPMENT_FINANCE } from '../../../utils/checkTenantFeatureFlag';
import FormParamEquipmentsServices from './FormParamEquipmentsServices';
import { InputAdornment } from '@mui/material';

import ModalCloneEquipmentModel from '../Modals/ModalCloneEquipmentModel';
import AttachmentsList from './AttachmentsList';

const FormParamEquipmentModels = (props) => {
  const dispatch = useDispatch();
  const matches = useMediaQuery('(min-width:1200px)');

  const [editMode, setEditMode] = useState(false);
  const [isNewData, setIsNewData] = useState(true);
  const [openCloneModal, setOpenCloneModal] = useState(false);

  // parametros para busca do autocomplete
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");

  const [editedIndex, setEditedIndex] = useState(-1);
  const [areaEditText, setAreaEditText] = useState("");
  const [isAddingNewArea, setIsAddingNewArea] = useState(false);
  const [actionRow, setActionRow] = useState("");

  // forms do empresas
  const [name, setName] = useState("");
  const [description, setDescription] = useState("")
  const [profile, setProfile] = useState([])
  const [equipmentServices, setEquipmentServices] = useState([]);
  const [annualDepreciation, setAnnualDepreciation] = useState('')


  //error forms
  const [nameError, setNameError] = useState(false);
  const [groupsError, setGroupsError] = useState(false);
  const [serviceTypesError, setServiceTypesError] = useState(false);
  const [frequencyError, setFrequencyError] = useState(false);

  const [profileError, setProfileError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);


  // selected values on autocomplete
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [searchTextGroups, setSearchTextGroups] = useState("")
  const [groupsFormated, setGroupsFormated] = useState([])

  const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
  const [searchTextServiceTypes, setSearchTextServiceTypes] = useState("")
  const [serviceTypesFormated, setServiceTypesFormated] = useState([])

  const [selectedFrequency, setSelectedFrequency] = useState([]);
  const [searchTextFrequency, setSearchTextFrequency] = useState("")
  const [frequencyFormated, setFrequencyFormated] = useState([])


  // fetch from BE

  const fetchGroups = useCallback(
    () => dispatch(actions.fetchGroups(page, limit, searchTextGroups, order, orderBy)),
    [page, limit, searchTextGroups, order, orderBy]
  );

  const fetchServiceTypes = useCallback(
    () => dispatch(actions.fetchServiceTypes(page, limit, searchTextServiceTypes, order, orderBy)),
    [page, limit, searchTextServiceTypes, order, orderBy]
  );

  const fetchFrequency = useCallback(
    () => dispatch(actions.fetchFrequency(page, limit, searchTextFrequency, order, orderBy)),
    [page, limit, searchTextFrequency, order, orderBy]
  );


  const fetchEquipmentModels = useCallback(
    () => dispatch(actions.fetchEquipmentModelById(props.match.params.id))
  );


  const checkDeleteEquipmentModels = () => dispatch(actions.checkDeleteEquipmentModels(props.match.params.id))
  const deleteEquipmentModels = () => dispatch(actions.deleteEquipmentModels(props.match.params.id))

  //get from redux
  const equipmentModel = useSelector(state => state.equipmentModels.equipmentModel);
  const groups = useSelector(state => state.groups.groups);
  const serviceTypes = useSelector(state => state.serviceTypes.serviceTypes);
  const frequency = useSelector(state => state.frequency.frequencies);

  const loadingEquipmentModels = useSelector(state => state.equipmentModels.loading);
  const loadingGroups = useSelector(state => state.groups.loading);
  const loadingServiceTypes = useSelector(state => state.serviceTypes.loading);
  const loadingFrequency = useSelector(state => state.frequency.loading);
  const tenantFeatureFlags = useSelector(state => state.auth.selectedAccess.tenant.tenantFeatureFlags);

  const loadingEquipmentServices = useSelector(state => state.equipmentServices.loading);

  //FUNCTION TO FORMAT TYPES IN THE AUTOCOMPLETE
  useEffect(() => {
    const dataFromRedux = groups
    let returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setGroupsFormated(returnArray)
  }, [groups])

  useEffect(() => {
    const dataFromRedux = serviceTypes
    let returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setServiceTypesFormated(returnArray)
  }, [serviceTypes])

  useEffect(() => {
    const dataFromRedux = frequency
    let returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setFrequencyFormated(returnArray)
  }, [frequency])

  useEffect(() => {
    fetchGroups(page, limit, searchTextGroups, order, orderBy);
  }, [searchTextGroups]);

  useEffect(() => {
    fetchServiceTypes(page, limit, searchTextServiceTypes, order, orderBy);
  }, [searchTextServiceTypes]);

  useEffect(() => {
    fetchFrequency(page, limit, searchTextFrequency, order, orderBy);
  }, [searchTextFrequency]);


  //check if is newEntrance or editing
  const recovery = () => {
    if (!isEmpty(equipmentModel) && props.match.params.id !== 'new') {
      setName(equipmentModel.name)
      setDescription(equipmentModel.description)
      setAnnualDepreciation(equipmentModel.annualDepreciation)
      const profileArray = []
      profileArray.push(equipmentModel.photo)
      setProfile(profileArray)
      let group = {}
      group = { value: equipmentModel.equipmentGroup._id, label: equipmentModel.equipmentGroup.name }
      setSelectedGroups(group)
      let equipmentServicesArr = [];
      equipmentModel.equipmentServices.map(equip => equipmentServicesArr.push({
        _id: equip._id,
        serviceType: {
          _id: equip.serviceType._id,
          name: equip.serviceType.name
        },
        frequency: {
          _id: equip.frequency._id,
          name: equip.frequency.name
        }
      }))
      setEquipmentServices(equipmentServicesArr);
    }
  }

  useEffect(() => {
    setIsNewData(props.match.params.id === 'new')
    if (props.match.params.id !== 'new') {
      fetchEquipmentModels()
    } else {
      setName("")

      setProfile([])
      setDescription("")
      setAnnualDepreciation('')
    }
  }, [])

  // in case editing, populate fields
  useEffect(() => {
    recovery()
  }, [equipmentModel])


  //send data to Server (post and update)
  const postEquipmentModels = (body) => dispatch(actions.postEquipmentModels(body))
  const updateEquipmentModels = (body) => dispatch(actions.updateEquipmentModels(props.match.params.id, body))

  const addServiceEquipmentModels = (index, inspectionId) => dispatch(actions.addServiceEquipmentModels(index, inspectionId))
  const removeServiceEquipmentModels = (index, inspectionId) => dispatch(actions.removeServiceEquipmentModels(index, inspectionId))


  const postEquipmentServices = (body) => dispatch(actions.postEquipmentServices(body))
  const updateEquipmentServices = (id, body) => dispatch(actions.updateEquipmentServices(id, body))
  const hardDeleteEquipmentServices = (id) => dispatch(actions.hardDeleteEquipmentServices(id))

  const handleSubmit = (e) => {
    if (!e) {
      return;
    }

    e.preventDefault();
    let hasError = false;

    if (!name) {
      setNameError(true);
      hasError = true
    }

    if (isEmpty(selectedGroups)) {
      setGroupsError(true);
      hasError = true
    }

    if (profile.length > 0 && profile[0]) {
      const notUploaded = profile.filter(fl => fl.uploaded === false)
      if (notUploaded.length > 0) {
        setProfileError(true)
        hasError = true;
      }
    }

    if (hasError) return

    let equipmentServicesArray = [];
    equipmentServices.map(inspect => equipmentServicesArray.push(inspect._id))

    const body = {
      "name": name.toUpperCase(),
      "description": description ? description.toUpperCase() : '',
      "equipmentGroup": selectedGroups.value,
      "equipmentServices": equipmentServicesArray,
      "annualDepreciation" : !annualDepreciation ? 0 : parseInt(annualDepreciation),
		}

    if (profile.length > 0 && profile[0] && (profile[0].id || profile[0]._id)) {
      body["photo"] = profile[0].id ? profile[0].id : profile[0]._id
    }

    if (isNewData) {
      postEquipmentModels(body).then(result => {
        if (result === 'success') {
          props.history.goBack()
        }
      })
    } else {
      updateEquipmentModels(body).then(result => {
        if (result === 'success') {
          setEditMode(false)
        }
      })
    }
  }

  const handleBack = () => {
    props.history.goBack()
  }


  const handleClose = () => {
    recovery()
    setEditMode(false);
  }

  const handleCheckDeleteEquipmentModels = (documentName) => {
    checkDeleteEquipmentModels().then((res) => {
      if (isEmpty(res)) {
        handleDeleteEquipmentModels(documentName)
      } else {
        handleDeleteEquipmentModelsFail(res)
      }
    })
  }

  const handleDeleteEquipmentModels = (docName) => {
    confirm(`${i18n.t('handleDeleteEquipmentModels.text')} ${docName}?`,
      {
        title: i18n.t('handleDeleteEquipmentModels.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          deleteEquipmentModels().then(() => {
            props.history.goBack()
          })
        },
      )
  }

  const handleDeleteEquipmentModelsFail = (obj) => {
    confirm(`${deleteCheckMessage(obj)}`,
      {
        title: i18n.t('handleDeleteEquipmentModelsFail.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
        },
      )
  }

  const handleInputChangeSelectorGroups = (text) => {
    setSearchTextGroups(text);
  }

  const handleInputChangeGroups = selected => {
    setGroupsError(false);
    setSelectedGroups(selected)
  }

  const handleInputChangeSelectorServiceTypes = (text) => {
    setSearchTextServiceTypes(text);
  }

  const handleInputChangeServiceTypes = selected => {
    setServiceTypesError(false);
    setSelectedServiceTypes(selected)
  }

  const handleInputChangeSelectorFrequency = (text) => {
    setSearchTextFrequency(text);
  }

  const handleInputChangeFrequency = selected => {
    setFrequencyError(false);
    setSelectedFrequency(selected)
  }

  const handleUploadPhoto = photo => {
    const uploadingFiles = photo.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      preview: URL.createObjectURL(file),
      fileType: file.type,
      progress: 0,
      uploaded: false,
      error: false,
      url: null
    }))

    setProfile(uploadingFiles)
    uploadingFiles.forEach(processUpload);

  }

  const updateFile = (id, data) => {
    setProfile(prevUf => prevUf.map(uf => id === uf.id ? { ...uf, ...data } : uf))
  };


  const processUpload = uploadedFile => {
    const data = new FormData();
    data.append("file", uploadedFile.file, uploadedFile.name);

    API.post("photos", data, {
      onUploadProgress: e => {
        const progress = parseInt(Math.round((e.loaded * 100) / e.total));
        updateFile(uploadedFile.id, {
          progress
        });
      }
    })
      .then(response => {
        setProfileError(false);
        updateFile(uploadedFile.id, {
          uploaded: true,
          id: response.data._id,
          url: response.data.url
        });
      })
      .catch(() => {
        updateFile(uploadedFile.id, {
          error: true
        });
      });
  }

  const editComponent = (index, obj) => {
    setEditedIndex(index);
    setAreaEditText(obj.name);
    setActionRow('editing');
    setIsAddingNewArea(false)
    setSelectedServiceTypes({ value: obj.serviceType._id, label: obj.serviceType.name })
    setSelectedFrequency({ value: obj.frequency._id, label: obj.frequency.name })
  };

  const cancelEdit = () => {
    setEditedIndex(-1);
  };

  const deleteComponent = (index, objIndex) => {
    //    fetchCheckDelete(objIndex);
    setEditedIndex(index);
    setActionRow('deleting');
  };

  const updateComponent = (index) => {
    if (actionRow === 'editing') {

      let hasError = false;

      if (!selectedServiceTypes) {
        setServiceTypesError(true)
        hasError = true
      }

      if (!selectedFrequency) {
        setFrequencyError(true);
        hasError = true
      }

      if (hasError) return;

      const body = {
        "serviceType": selectedServiceTypes.value,
        "frequency": selectedFrequency.value,
      }

      updateEquipmentServices(index, body).then(result => {
        if (result !== 'error') {
          const equipmentServicesArray = [...equipmentServices];
          const indexArray = equipmentServicesArray.findIndex(ia => ia._id === index);
          equipmentServicesArray[indexArray] = {
            ...equipmentServicesArray[indexArray],
            serviceType: result.serviceType,
            frequency: result.frequency,
          }
          setEquipmentServices(equipmentServicesArray)
          setEditedIndex(-1);
        }
      })

    } else if (actionRow === 'deleting') {
      if (isNewData) {
        hardDeleteEquipmentServices(index).then(result => {
          if (result === 'success') {
            let equipmentServicesArray = [...equipmentServices];
            const indexArr = equipmentServicesArray.findIndex(va => va._id === index);
            equipmentServicesArray.splice(indexArr, 1);
            setEquipmentServices(equipmentServicesArray);
            setEditedIndex(-1);

          }
        })
      } else {
        removeServiceEquipmentModels(props.match.params.id, index).then(result => {
          if (result === 'success') {
            let equipmentServicesArray = [...equipmentServices];
            const indexArr = equipmentServicesArray.findIndex(va => va._id === index);
            equipmentServicesArray.splice(indexArr, 1);
            setEquipmentServices(equipmentServicesArray);
            setEditedIndex(-1);
          }
        })
      }
    }
  };

  const addNewAreaRow = () => {
    setIsAddingNewArea(!isAddingNewArea)
    setEditedIndex(-1);
    setSearchTextFrequency("")
    setSelectedFrequency("")
    setSearchTextServiceTypes("")
    setSelectedServiceTypes("")
  }

  const createComponent = () => {

    let hasError = false;

    if (!selectedServiceTypes) {
      setServiceTypesError(true)
      hasError = true
    }

    if (!selectedFrequency) {
      setFrequencyError(true);
      hasError = true
    }

    if (hasError) return;

    const body = {
      "serviceType": selectedServiceTypes.value,
      "frequency": selectedFrequency.value,
    }

    postEquipmentServices(body).then(result => {
      if (result !== 'error') {
        setIsAddingNewArea(!isAddingNewArea)
        const equipmentServicesArray = [...equipmentServices];
        equipmentServicesArray.push(result)
        setEquipmentServices(equipmentServicesArray)
        if (!isNewData) {
          addServiceEquipmentModels(props.match.params.id, result._id)
        }
      }
    })

  }

  const createCancel = () => {
    setIsAddingNewArea(false)
  }

  const serviceTypesAutocomplete = () => {
    return (
      <Autocomplete
        loading={loadingServiceTypes} //sent to isLoading
        label={i18n.t('autocompleteFormParamEquipModel.serviceTypes')}
        data={serviceTypesFormated} // sent to options
        onSelectValue={handleInputChangeServiceTypes} // sent to onChange
        valueSelected={selectedServiceTypes} // sent to value
        newSearchText={handleInputChangeSelectorServiceTypes}
        name='serviceType'
        hasError={serviceTypesError}
        disabled={!isNewData && !editMode}
      />
    );
  };

  const frequencyAutocomplete = () => {
    return (
      <Autocomplete
        loading={loadingFrequency} //sent to isLoading
        label={i18n.t('autocompleteFormParamEquipModel.frequency')}
        data={frequencyFormated} // sent to options
        onSelectValue={handleInputChangeFrequency} // sent to onChange
        valueSelected={selectedFrequency} // sent to value
        newSearchText={handleInputChangeSelectorFrequency}
        name='frequency'
        hasError={frequencyError}
        disabled={!isNewData && !editMode}
      />
    );
  };

  const handleCloseCloneEquipmentModel = () => {
    setOpenCloneModal(false)
  }

  const handleEdit = () => {
    setEditMode(true)
  }

  return <>
    <Dialog
      scroll='body'
      fullWidth
      open={openCloneModal}
      onClose={() => handleCloseCloneEquipmentModel()}
      PaperProps={{
        style: {
          overflow: 'visible'
        },
      }}
    >
      <ModalCloneEquipmentModel
        closeModal={() => handleCloseCloneEquipmentModel()}
        idEquipToBeCloned={props.match.params.id}
      />
  </Dialog>

    <IconButton onClick={handleBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>
    <div style={matches ? styles.divContainer : styles.divContainerSmall}>

      <div>
        <Container maxWidth='sm' style={styles.container}>
          <Paper style={{ position: 'relative' }}>
            {loadingEquipmentModels && <Spinner overlay />}

            {/* form equipamentos */}
            <FormStyled onSubmit={handleSubmit} style={{ opacity: loadingEquipmentModels ? '0.3' : '1' }}>
              <DivFormTitle>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <Typography variant='h6'>{props.match.params.id === 'new' ? i18n.t('typographyFormParamEquipModel.true') : i18n.t('typographyFormParamEquipModel.false')}</Typography>
                  {props.match.params.id !== 'new' &&
                    <IconButton onClick={() => setOpenCloneModal(true)} size="large">
                      <Tooltip title={i18n.t('tooltipFormParamEquipModel.title')}>
                        <FileCopyTwoToneIcon />
                      </Tooltip>
                    </IconButton>}
                </div>
                {!isNewData &&
                  <DivSubmitButtons>
                    {editMode ?
                      <>
                        <IconButton onClick={handleClose} size="large"><CloseIcon color='error' /></IconButton>
                        <IconButton
                          disabled={annualDepreciation < 0 || annualDepreciation > 100}
                          type="submit"
                          size="large"><DoneIconStyled /></IconButton>
                      </> :
                      <>
                        <IconButton onClick={() => handleEdit()} size="large">
                          <Tooltip title='editar'><EditIcon /></Tooltip>
                        </IconButton>
                        <IconButton onClick={() => handleCheckDeleteEquipmentModels(name)} size="large">
                          <Tooltip title='deletar'><DeleteIcon /></Tooltip>
                        </IconButton>
                      </>
                    }
                  </DivSubmitButtons>
                }
              </DivFormTitle>
              <Divider />

              <>
                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    multiline
                    label={i18n.t('textFieldFormEquipModel.name')}
                    name='name'
                    onChange={event => { setNameError(false); return setName(event.target.value) }}
                    value={name}
                    margin='normal'
                    error={nameError}
                    disabled={!isNewData && !editMode} />
                </FormControl>

                <FormControl variant="standard" fullWidth margin='normal'>
                  <Autocomplete
                    loading={loadingGroups} //sent to isLoading
                    label={i18n.t('autocompleteFormParamEquipModel.groups')}
                    data={groupsFormated} // sent to options
                    onSelectValue={handleInputChangeGroups} // sent to onChange
                    valueSelected={selectedGroups} // sent to value
                    newSearchText={handleInputChangeSelectorGroups}
                    name='group'
                    hasError={groupsError}
                    disabled={!isNewData && !editMode}
                  />
                </FormControl>

                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    multiline
                    label={i18n.t('textFieldFormEquipModel.description')}
                    name='description'
                    onChange={event => { setDescriptionError(false); return setDescription(event.target.value) }}
                    value={description}
                    margin='normal'
                    error={descriptionError}
                    disabled={!isNewData && !editMode} />
                </FormControl>

                {checkTenantFeatureFlag(VIEW_EQUIPMENT_FINANCE, tenantFeatureFlags) &&
                  <div style={{ paddingTop: '20px'}}>

                  <FormControl variant="standard">
                    <InputLabel shrink htmlFor="annualDepreciation">{i18n.t('textFieldFormEquipModel.labelDepreciation')}</InputLabel>
                    <Input
                      style={{ width: '7rem' }}
                      type="number"
                      name='annualDepreciation'
                      label={i18n.t('textFieldFormEquipModel.labelDepreciation')}
                      value={annualDepreciation}
                      onChange={event => { setAnnualDepreciation(event.target.value) }}
                      error={annualDepreciation < 0 || annualDepreciation > 100}
                      margin='normal'
                      disabled={!isNewData && !editMode}
                      endAdornment={<InputAdornment position="end">%</InputAdornment>}
                    />
                    <FormHelperText>{i18n.t('textFieldFormEquipModel.labelPercentualDepreciation')}</FormHelperText>
                  </FormControl>
                  </div>
                }
              </>

              {isNewData &&
                <DivSubmitButtons>
                  <IconButton onClick={props.history.goBack} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
                  <IconButton
                    disabled={annualDepreciation < 0 || annualDepreciation > 100}
                    type="submit"
                    size="large"><DoneIconStyled fontSize='large' /></IconButton>
                </DivSubmitButtons>}
            </FormStyled>
          </Paper>
        </Container>

      {/* form anexos */}
      {!isNewData &&
        <Container maxWidth='sm' style={styles.container} >
          <AttachmentsList fullWidth />
        </Container>
      }
      </div>

      {/* form serviços do equipamento */}
      {!isNewData && <FormParamEquipmentsServices {...props} />}

    </div>
  </>;
}

export default FormParamEquipmentModels;

const styles = {
  arrowBack: {
    position: 'fixed',
    marginTop: 10,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 50,
    marginBottom: 300,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignGroups: 'center',
  },
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: 'relative',
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignGroups: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20,
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignGroups: 'center',
    flexDirection: 'column'
  },
  equipContainer: {
    margin: '20px 0',
  },
  equipTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignGroups: 'center',
  },
  chipContainer: {
    margin: '10px 0'
  },
  verifContainer: {
    margin: '20px 0',
  },
  spinner: {
    position: 'absolute',
    display: 'flex',
    alignGroups: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    top: '-5px',
    opacity: '1',
    zIndex: 2,
  },
}
